import React, { useState } from "react";
import EntryColor from "../container/EntryColor";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import FlatViewQuinella from "./FlatViewQuinella";
import SwitchActiveBetsColum from "../utilities/SwitchActiveBetsColum";
import ButtonOpenBetsBetType from "../utilities/ButtonOpenBetsBetType";

const Quinella = ({
  entries,
  charts,
  otherViews,
  getOpenBetsChartModal,
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  idQuinella,
  raceID,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  getCharts,
}) => {
  const [showBetsColumnQ, setShowBetsColumnQ] = useState(false);
  var totalEntries = entries.length + 1;
  var qArray = new Array(totalEntries);

  //Bucle para meter en cada posición otros array de 10
  for (var i = 0; i < totalEntries; i++) {
    qArray[i] = new Array(totalEntries);
  }

  entries.forEach((entry, k) => {
    qArray[0][k + 1] = entry.EntryNum;
    qArray[k + 1][0] = entry.EntryNum;
  });

  charts.forEach((chart, i) => {
    let selections = chart.Selections.split(",");
    qArray[selections[0]][selections[1]] = String(
      chart.Amount + "," + chart.BetCount
    );
  });

  //Recorrer chart y sacar los selections con split y agregarlos en quinellaArray
  var tableContent = [],
    headers = [],
    tdQuinella = [],
    tdFirstLeg = [];

  for (let i = 0; i < qArray.length; i++) {
    //columnas
    for (let j = 0; j < qArray[i].length; j++) {
      //filas
      let colorHeader;

      if (i === 0) {
        let colspan;
        if (i === 0 && j !== 0) {
          colspan = 2;
          colorHeader = "#00334d";
        }
        headers.push(
          <th
            colSpan={showBetsColumnQ ? colspan : 1}
            style={{
              verticalAlign: "middle",
              backgroundColor: colorHeader,
            }}
            key={j}
          >
            <EntryColor
              entryNum={qArray[i][j]}
              saddleNum={qArray[i][j]}
              finishPos={
                qArray[i][j] !== undefined
                  ? entries[qArray[i][j] - 1].FinishPos
                  : null
              }
            />
          </th>
        );
      }

      if (j !== 0 && i !== 0) {
        //This variable (selections) is used as a parameter to query getOpenBetsChart
        let selections = i + "," + j.toString();

        let amount = qArray[i][j];
        if (amount) {
          let values = amount.split(",");
          tdQuinella.push(
            <React.Fragment key={j}>
              <td style={{ verticalAlign: "middle", fontWeight: "bold" }}>
                ${parseFloat(values[0]).toFixed(2)}
              </td>
              {showBetsColumnQ && (
                <td
                  style={{ verticalAlign: "middle" }}
                  className="cantBets"
                  data-toggle="modal"
                  data-target="#openBetsChartModal"
                  onClick={() => getOpenBetsChartModal(idQuinella, selections)}
                >
                  {values[1]}
                </td>
              )}
            </React.Fragment>
          );
        } else if (j === i) {
          tdQuinella.push(
            <React.Fragment key={j}>
              <td
                colSpan={showBetsColumnQ ? 2 : 1}
                style={{ backgroundColor: "#dee2e6" }}
              ></td>
            </React.Fragment>
          );
        } else {
          tdQuinella.push(
            <React.Fragment key={j}>
              <td
                colSpan={showBetsColumnQ ? 2 : 1}
                style={{ verticalAlign: "middle" }}
              ></td>
            </React.Fragment>
          );
        }
      }

      if (j === 0 && i !== 0) {
        tdFirstLeg.push(
          <React.Fragment key={j}>
            <td className="firstLegTD" key={j}>
              {
                <EntryColor
                  entryNum={qArray[i][j]}
                  saddleNum={qArray[i][j]}
                  finishPos={
                    qArray[i][j] !== undefined
                      ? entries[qArray[i][j] - 1].FinishPos
                      : null
                  }
                />
              }
            </td>
          </React.Fragment>
        );
      }
    }
    tableContent.push(
      <React.Fragment key={i}>
        <tr>
          {tdFirstLeg}
          {tdQuinella}
        </tr>
      </React.Fragment>
    );

    tdQuinella = [];
    tdFirstLeg = [];
  }

  return (
    <>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={idQuinella}
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        scoreTickets={scoreTickets}
        setCallTicketVoidListFrom={setCallTicketVoidListFrom}
        getCharts={getCharts}
      />
      <div className="row">
        <div className="col-sm-6">
          <SwitchActiveBetsColum
            showBetsColumn={showBetsColumnQ}
            setShowBetsColumn={setShowBetsColumnQ}
          />
        </div>
        <div className="col-sm-6" style={{ textAlign: "right" }}>
          <ButtonOpenBetsBetType
            ticketType={idQuinella}
            raceID={raceID}
            userInfo={userInfo}
            openBetsChartInfo={openBetsChartInfo}
            setOpenBetsChartInfo={setOpenBetsChartInfo}
          />
        </div>
      </div>

      {!otherViews ? (
        <>
          <div className="mb-2" style={{ textAlign: "right" }}>
            <span
              className="badge rounded-circle"
              style={{ backgroundColor: "#79a6d2", color: "transparent" }}
            >
              ..
            </span>
            <span className="mr-3 ml-1">First Leg</span>
            <span
              className="badge rounded-circle"
              style={{ backgroundColor: "#00334d", color: "transparent" }}
            >
              ..
            </span>
            <span className="ml-1">Second Leg</span>
          </div>
          <table className="table table-bordered table-sm">
            <thead className="theadFixed">
              <tr className="text-center">{headers}</tr>
            </thead>
            <tbody className="table-sm text-center table-bordered">
              {tableContent}
            </tbody>
          </table>
        </>
      ) : (
        <FlatViewQuinella
          charts={charts}
          getOpenBetsChartModal={getOpenBetsChartModal}
          idQuinella={idQuinella}
          showBetsColumnQ={showBetsColumnQ}
        />
      )}
    </>
  );
};

export default Quinella;
